import PropTypes from "prop-types";

export const formPropTypes = {
  base: PropTypes.func.isRequired,
};
